import { Box, Typography } from '@mui/material'
import { FileList, FileUpload } from 'components'
import { Modal } from 'components/common/modal'
import { Step } from 'models'
import React from 'react'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'

interface StepFilesModalProps {
  isOpen:       boolean,
  targetStep:   Step,
  isThumbnail?: boolean,
  onClose: () => void,
}

// TODO disable file list for none draft courses
export const StepFilesModal: React.FC<StepFilesModalProps> = observer(({ isThumbnail, isOpen, onClose, targetStep }) => {
  const { t } = useTranslation()

  const showUpload: boolean = !isThumbnail || !targetStep.getThumbnail;

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Typography variant='h4'>{t('editor_step_files_title')}</Typography>
      <Box
        display       = 'flex'
        flexDirection = 'column'
        alignItems    = 'center'
        mt            = {2}
      >
        {showUpload && 
          <FileUpload onUpload={(file) => targetStep.addDocument(file)} isThumbnail={isThumbnail}/>
        }
        <Box mb={2}></Box>
        <FileList
          files    = {isThumbnail ? [targetStep.thumbnail].filter(Boolean) : targetStep.getDocuments}
          onDelete = {(file) => targetStep.removeDocument(file)}
          isEdit
        />
      </Box>
    </Modal>
  );
});
